import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getSubstitutionStatus,
} from "../../helper";
import config from './../../config';
import common from './../../common';
import MoreMenu from './../../components/onboarding/MoreMenu';
import NextBtn from './../onboarding/NextBtn';

class TopSectionHeader extends Component {
    handleNext = (btnType) => {
        this.props.handleNext(btnType);
    };

    render() {
        const pathStep = this.props.pathStep;
        const { trans, teamData, manageTeamRawData, manageTeamMode, viewState } = this.props;
        const isManageTeam = common.isManageTeam();
        const teamPoints = teamData['OVPoints'];
        const showTeamPoints = !(teamPoints === undefined || teamPoints === null || teamPoints === '');
        let teamName = '';
        let buttonTypes = null;
        let title = '';
        if (isManageTeam) {
            teamName = common.getTeamName();
            const viewTeamMode = manageTeamMode === config.modes["view-manage-team"];
            const transferMode = manageTeamMode === config.modes["transfer"];
            const substitutionMode = manageTeamMode === config.modes["substitution"];
            let showNextBtn = false;
            let showTransferBtn = false;
            let showSubstitutionBtn = false;
            let showSubsConfirmButtons = false;
            let showSubsCancelButtons = false;
            let showActionBtn = false;
            title = teamName ? teamName : '';
            if (viewState !== config.possibleActions["live"]) {
                if (viewTeamMode) {
                    if (viewState) {
                        if (viewState === config.possibleActions["substitution"]) {
                            showActionBtn = true;
                            showSubstitutionBtn = true;
                        } else if (viewState === config.possibleActions["transfer"] || viewState === config.possibleActions["subsAndTransfer"]) {
                            showActionBtn = true;
                            showTransferBtn = true;
                        }
                    }
                } else if (substitutionMode) {
                    showActionBtn = true;
                    showSubsConfirmButtons = true;
                    showSubsCancelButtons = true;
                } else if (transferMode) {
                    showActionBtn = true;
                    showNextBtn = true;
                }
                let nextBtnProps = {};
                let cancelBtnProps = {};
                let btnWrapClass = common.makeClasses({
                    'si-btn-wrp': !(substitutionMode),
                    'si-subs-mode-btn': (substitutionMode),
                    'si-flexBox': (substitutionMode),
                });
                if (showTransferBtn) {
                    nextBtnProps = {
                        isDisabled: this.props.isDisabled,
                        showTitle: this.props.isDisabled,
                        tooltipText: this.props.trans.transfer,
                        showIcon: true,
                        isTransferBtn: true,
                        iconClass: 'icon-ucl-transfers',
                        text: this.props.trans.transfer,
                        handler: () => this.handleNext("transfer"),
                    }
                } else if (showSubstitutionBtn) {
                    nextBtnProps = {
                        isDisabled: this.props.isDisabled,
                        showTitle: this.props.isDisabled,
                        tooltipText: this.props.trans.makeSubstitutions,
                        showIcon: true,
                        isSubsBtn: true,
                        iconClass: 'icon-ucl-subsitute',
                        text: this.props.trans.substitutePc,
                        handler: () => this.handleNext("substitute"),
                    }
                } else if (showSubsConfirmButtons && showSubsCancelButtons) {
                    cancelBtnProps = {
                        isDisabled: false,
                        showTitle: this.props.isDisabled,
                        tooltipText: this.props.trans.cancel,
                        isNoBorder: true,
                        text: this.props.trans.cancel,
                        handler: () => this.handleNext("cancel"),
                    };
                    nextBtnProps = {
                        isDisabled: this.props.isDisabled,
                        showTitle: this.props.isDisabled,
                        tooltipText: this.props.trans.confirm,
                        text: this.props.trans.confirm,
                        handler: () => this.handleNext("confirm"),
                    }
                } else if (showNextBtn) {
                    nextBtnProps = {
                        isDisabled: this.props.isDisabled,
                        showTitle: this.props.isDisabled,
                        tooltipText: this.props.trans.next,
                        text: this.props.trans.next,
                        handler: () => this.handleNext("next"),
                    }
                }
                if (showActionBtn) {
                    if (showSubsCancelButtons) {
                        buttonTypes = <div className={ btnWrapClass }>
                            { showSubsCancelButtons ? <NextBtn { ...cancelBtnProps } /> : null }
                            <NextBtn { ...nextBtnProps } />
                        </div>;
                    } else {
                        buttonTypes = <NextBtn { ...nextBtnProps } />;
                    }
                }
                /* si-title content start */
                if (pathStep === 13) {
                    title = trans.menu_matches;
                }
                if (substitutionMode) {
                    let subStatus = getSubstitutionStatus(manageTeamRawData, teamData);
                    let isSubstituted = subStatus.substituted;
                    let subCount = subStatus.count;
                    let isSubInit = teamData.substitutionInitiated;
                    /*let isSubComplete = teamData.substitutionCompleted;*/
                    if (isSubstituted && !isSubInit) {
                        title = subCount + ' ' + trans.substitutionMade;
                        if (subCount > 1) {
                            title = subCount + ' ' + (trans.substitutionsMade ? trans.substitutionsMade : "SUBSTITUTIONS MADE");
                        }
                    } else if (isSubInit) {
                        title = trans.pickReplacement;
                    } else {
                        title = trans.pickToSubstitute;
                    }
                }
                /* si-title content end */
            }
            return <React.Fragment>
                {
                    !transferMode ?
                        <div className="si-heading-wrap si-flexBox">
                            <div className="si-title"><span>{ title }</span></div>
                            { buttonTypes }
                        </div> : null
                }
                { viewTeamMode ? <div className="si-overall-info si-flexBox">
                    <div className="si-back-btn si-cols">
                        <i className="icon-ucl-main-menu" />
                    </div>
                    <div className="si-cols si-header-txt">
                        <span>{ title }</span>
                    </div>
                    { (showTeamPoints) ? <div className="si-plyr-score si-flexBox">
                        <span>{ trans.yourScore }</span>
                        <div className="si-score-wrap">
                            <span className="si-pts">{ teamPoints }</span>
                            <span className="si-pts-txt"> { trans.labelPts }</span>
                        </div>
                    </div> : null }
                    <MoreMenu />
                </div> : null }
            </React.Fragment>
        }
        else {
            if (pathStep === 13) {
                title = trans.menu_matches;
            }
            return <React.Fragment>
                <div className="si-heading-wrap si-flexBox">
                    <div className="si-title"><span>{ title }</span></div>
                </div>
                <div className="si-overall-info si-flexBox">
                    <div className="si-back-btn si-cols">
                        <i className="icon-ucl-main-menu" />
                    </div>
                    <div className="si-cols si-header-txt">
                        <span>{ title }</span>
                    </div>
                    { (showTeamPoints) ? <div className="si-plyr-score si-flexBox">
                        <span>{ trans.yourScore }</span>
                        <div className="si-score-wrap">
                            <span className="si-pts">{ teamPoints }</span>
                            <span className="si-pts-txt"> { trans.labelPts }</span>
                        </div>
                    </div> : null }
                    <MoreMenu />
                </div>
            </React.Fragment>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
        manageTeamRawData: state.formationData.manageTeamRawData,
        manageTeamMode: state.formationData.manageTeamMode,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(TopSectionHeader);


// WEBPACK FOOTER //
// ./src/components/manage-team/Top-Section-Header.js